import React from 'react';
import { RenderPhone } from '../renders';

const TableRenderPhone = column => rowData => (
  <RenderPhone value={rowData[column]} />
);

export default TableRenderPhone;
